import BaseService, { getApplication } from "./BaseService.js";

class EventsService extends BaseService {
  getForm({ module, scope, namespace }) {
    return this.apiGet({
      url: `/${module}/form`,
      params:  { namespace: 'tazamaEvents', scope },
    });
  }

  getVersioning(id) {
    const app = getApplication();

    return this.apiGet({
      url: `/${app}/versioning/datapoints/Event/${id}`,
    });
  }

  getWithModule({ query, signal, module }) {
    return this.apiGet({
      url: `/${module}/event`,
      params: query,
      signal,
    });
  }

  getOne({ id, module, signal }) {
    return this.apiGet({
      url: `/${module}/event/${id}`,
      signal,
    });
  }

  // needs to adapt to the backend
  get(query, signal) {
    return this.apiGet({
      url: "/events",
      params: query,
      signal,
    });
  }

  // needs to adapt to the backend
  getData(query) {
    return this.apiGet({
      url: "/event/data",
      params: query
    });
  }

  getLinking(query) {
    return this.apiGet({
      url: "/event/linking",
      params: query
    });
  }

  // needs to adapt to the backend
  submit(payload) {
    if (payload.id) {
      const { id, ...data } = payload;

      if (['tazama'].includes(payload.module)) {
        return this.apiPut({
          url: `/${payload.module}/event/${id}`,
          data,
        });
      }

      return this.apiPut({
        url: `/event/${id}`,
        data,
      });
    }

    if (['tazama'].includes(payload.module)) {
      return this.apiPost({
        url: `/${payload.module}/event`,
        data: payload,
      });
    }

    return this.apiPost({
      url: "/event",
      data: payload,
    });
  }

  publish(id) {
    return this.apiPost({
      url: `/event/${id}/publish`,
    });
  }

  remove(id, data, mod) {
    if (mod) {
      return this.apiDelete({
        url: `/${mod}/event/${id}`,
        data: data,
      });
    }

    return this.apiDelete({
      url: `/event/${id}/remove`,
      data: data,
    });
  }

  submitForm(id) {
    const app = getApplication();

    return this.apiPost({
      url: `/${app}/versioning/submit/Event/${id}`,
    });
  }
}

export default new EventsService();
